const getTokenFromSearchParams = (params: URLSearchParams): string | undefined => {
  const candidateKeys = ["access_token", "token", "jwt", "bearer", "bearer_token"];

  for (const key of candidateKeys) {
    const value = params.get(key);
    if (value?.trim()) {
      return value.trim();
    }
  }

  return undefined;
};

const getTokenFromContext = (context: unknown): string | undefined => {
  if (!context || typeof context !== "object") {
    return undefined;
  }

  const record = context as Record<string, unknown>;
  const tokenKeys = ["access_token", "accessToken", "jwt", "token", "bearer", "bearerToken"];

  for (const key of tokenKeys) {
    const value = record[key];
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }

  const nestedKeys = ["data", "authorization", "auth", "tokens"];

  for (const nestedKey of nestedKeys) {
    const nested = record[nestedKey];
    const nestedToken = getTokenFromContext(nested);
    if (nestedToken) {
      return nestedToken;
    }
  }

  return undefined;
};

export const extractAccessToken = (...contexts: unknown[]): string | undefined => {
  if (typeof window !== "undefined") {
    const queryToken = getTokenFromSearchParams(new URLSearchParams(window.location.search));
    if (queryToken) {
      return queryToken;
    }

    const hashValue = window.location.hash.startsWith("#")
      ? window.location.hash.slice(1)
      : window.location.hash;
    const hashToken = getTokenFromSearchParams(new URLSearchParams(hashValue));
    if (hashToken) {
      return hashToken;
    }
  }

  for (const context of contexts) {
    const token = getTokenFromContext(context);
    if (token) {
      return token;
    }
  }

  return undefined;
};

export const extractOrgId = (sdkOrgId: unknown, ...contexts: unknown[]): string | undefined => {
  if (typeof sdkOrgId === "string" && sdkOrgId.trim()) {
    return sdkOrgId.trim();
  }

  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    const qOrgId = params.get("org_id") || params.get("organization");

    if (qOrgId?.trim()) {
      return qOrgId.trim();
    }
  }

  for (const context of contexts) {
    const ctx = context as
      | { organization?: { id?: unknown }; org_id?: unknown; organization_id?: unknown }
      | undefined;
    const orgId = ctx?.organization?.id || ctx?.org_id || ctx?.organization_id;

    if (typeof orgId === "string" && orgId.trim()) {
      return orgId.trim();
    }
  }

  return undefined;
};
